import React from "react";
import { useParams } from "react-router-dom";
import SiteTerminologyContent from "./SiteTerminologyContent";

const SiteTerminology = ({ state, dispatch }) => {
	const { appId, id: siteId } = useParams();

	return (
		<SiteTerminologyContent
			state={state}
			dispatch={dispatch}
			scope={{ level: "siteapp", id: Number(appId), siteId: Number(siteId) }}
		/>
	);
};

export default SiteTerminology;
